import React from "react";
import styled from "styled-components";

import theme from "../../../styles/theme";

const StyledMenu = styled.div`
  position: fixed;
  top: 48px;
  left: 0;
  width: 100%;
  height: calc(110vh - 48px);
  overflow-x: hidden;
  overflow-y: scroll;
  background: ${() => theme.colors.green1};
  z-index: 500;
  padding-top: 60px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  pointer-events: none;
  opacity: 0;
  overflow: hidden;
  height: 0;
  transition: opacity 0.5s ease-in-out, height 0.5s ease-in-out;
  ${(props) =>
    props.open &&
    `
    pointer-events: auto;
    opacity: 1;
    height: calc(100vh - 48px);
  `}
`;

const MobileMenu = ({open, children, className }) => {
  return <StyledMenu open={open} className={className}><div style={{overflow: 'auto', height: 'calc(100vh - 48px)'}}>{children}</div></StyledMenu>;
};

export default MobileMenu;
